import {formatAddress, parsePhoneNumbers} from 'presentation/utils';

import {FlowEnum} from 'presentation/pages/private/booking/constants/flowEnum';

import {ParseHealthUnitsProps} from './types';
import {Units} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';

const extractUnitNumber = (address: string) => {
	const match = address?.match(/\b\d+\b/);
	return match ? match[0] : '';
};

export const parseHealthUnits = ({
	units,
	isAccreditedV2Network,
}: ParseHealthUnitsProps): Units<FlowEnum.HEALTH>[] =>
	units?.map(unit => {
		const unitNumber = isAccreditedV2Network
			? extractUnitNumber(unit.logradouro)
			: unit?.numero?.toString() || unit?.nuEnderecoComercial?.toString();

		return {
			code: unit?.codigo?.toString(),
			name: unit?.nome || unit?.nomeMedico || unit?.nmFantasia || unit?.nmPrestador,
			stateCode: unit?.cdUf,
			stateName: unit?.nmEstado,
			city: unit?.nmCidade,
			addressNumber: unit?.numero?.toString(),
			addressName: unit?.logradouro,
			addressComplement: unit?.complemento,
			district: unit?.bairro,
			cep: unit?.cep,
			latitude: unit?.latitude,
			longitude: unit?.longitude,
			distance: unit?.distancia ?? (unit as unknown as {nuDistancia?: number})?.nuDistancia,
			telemedicine: unit?.telemedicina,
			nmBairroOrigem: unit?.nmBairroOrigem,
			phoneNumbers: parsePhoneNumbers(unit?.telefone || unit?.nuTelefone),
			formattedAddress: formatAddress({
				state: unit?.cdUf,
				city: unit?.nmCidade,
				number: unitNumber,
				address: unit?.logradouro || unit?.dsEndereco || unit?.enderecoComercial,
				complement:
					unit?.complemento ||
					unit?.dsComplEndereco ||
					unit?.complementoEnderecoComercial,
				district: unit?.bairro || unit?.nmBairro,
			}),
			isSpecialtyBlocked: unit?.especialidadeBloqueada || false,
		};
	});
